import React, { useState } from "react";
import PostOnboardingModal from "./PostOnboardingModal";

const PostOnboardingBanner: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFinishClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="w-full border border-[#2D375B] rounded-lg bg-white px-6 py-4 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01"
              stroke="#2D375B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-[#2D375B] text-base font-normal">There are still a few items to do to get fully paid.</p>
        </div>
      </div>
      <button
        onClick={handleFinishClick}
        className="bg-docnote-orange hover:bg-orange-600 text-white px-6 py-2 rounded-full font-medium transition-colors duration-200 flex-shrink-0"
      >
        Finish Office Setup
      </button>
      <PostOnboardingModal open={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default PostOnboardingBanner;
